<template>
  <v-text-field :value="value"
                :label="label"
                :type="type"
                :mask="mask"
                :placeholder="placeholder"
                :return-masked-value="returnMaskedValue"
                :class="$style.input"
                v-bind="$attrs"
                color="#38AA3F"
                v-on ="$listeners"
                @input="$emit('input', $event)"/>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

@Component({
  name:  'InputField',
  props: {
    value:             '',
    label:             '',
    mask:              '',
    placeholder:       '',
    type:              '',
    returnMaskedValue: {
      type:    Boolean,
      default: false,
    },
  },
})
export default class InputField extends Vue {}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";
@import "~@/style/helpers.scss";

.input input {
  font-family: $main-font-family;
  font-size: rem(13px);
  font-weight: 300;
}
</style>




// WEBPACK FOOTER //
// src/components/InputField.vue